// extracted by mini-css-extract-plugin
export default {"faqs":"gr-z","faqContent":"hr-z","faq":"ir-z"};